import React from 'react';
import {Link} from 'react-router-dom'

export default function Products() {
  return (
    <div>
      
      <section id="services" className="services">
      <div className="container">

        <div className="section-title">
          {/* <span>Services</span> */}
          <h2> PRODUCTS </h2>
          <p> DISCOVER A RANGE OF INSURANCE PRODUCTS TAILORED FOR YOUR PEACE OF MIND </p>
        </div>

        <div className="row">
          <div className="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="fade-up">
            <div className="icon-box">
              {/* <div className="icon"><i className="bx bxl-dribbble"></i></div> */}
              <div className="icon"><i class="fa fa-plane" aria-hidden="true"></i></div>

              <h4><Link to="/travel"> TRAVEL INSURANCE </Link></h4>
              <p> Prepare for worry-free travels with our comprehensive Travel Insurance <br/> From unexpected cancellations to medical emergencies,we've got you covered </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-md-0" data-aos="fade-up" data-aos-delay="150">
            <div className="icon-box">
              {/* <div className="icon"><i className="bx bx-file"></i></div> */}
              <div className="icon"><i class="fa fa-medkit" aria-hidden="true"></i></div>

              <h4><Link to="/health"> HEALTH INSURANCE </Link></h4>
              <p> Secure your health and peace of mind with our comprehesive Insurance plans <br/> Our tailored coverage ensures you're protected when it matters most </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-lg-0" data-aos="fade-up" data-aos-delay="300">
            <div className="icon-box">
              {/* <div className="icon"><i className="bx bx-tachometer"></i></div> */}
              <div className="icon"><i class="fa fa-car" aria-hidden="true"></i></div>

              <h4><Link to="/car" >CAR INSURANCE </Link></h4>
              <p> Drive confidently knowing you're protected by our comprehensive Car Insurance <br/> Tailored coverage for your vehicle's security on and off the road </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4" data-aos="fade-up" data-aos-delay="450">
            <div className="icon-box">
              {/* <div className="icon"><i className="bx bx-world"></i></div> */}
              <div className="icon"><i class="fa fa-motorcycle" aria-hidden="true"></i></div>

              <h4><Link to="/bike"> BIKE INSURANCE </Link></h4>
              <p> Ride with confidence with our specialized Bike Insurance <br/> Tailored coverage to safeguard your bike </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4" data-aos="fade-up" data-aos-delay="600">
            <div className="icon-box">
              {/* <div className="icon"><i className="bx bx-slideshow"></i></div> */}
              <div className="icon"><i class="fa fa-user-md" aria-hidden="true"></i></div>

              <h4><Link to="/life"> LIFE INSURANCE </Link></h4>
              <p> Protect your loved ones' future with our comprehensive Life Insurance coverage <br/> Secure peace of mind knowing their financial well-being is assured </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4" data-aos="fade-up" data-aos-delay="750">
            <div className="icon-box">
              {/* <div className="icon"><i className="bx bx-arch"></i></div> */}
              <div className="icon"><i class="fa fa-podcast" aria-hidden="true"></i></div>

              <h4><Link to="/cartracker"> CAR TRACKER </Link></h4>
              <p> Enhance your car's security with our advanced tracking systems <br/> Safeguard your vehicle and monitor its whereabouts with ease </p>
            </div>
          </div>

        </div>

      </div>
    </section>

    </div>
  )
}
